import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { IEntityDataProvider } from '../interfaces/entity-data-provider.interface';
import { Doctrines, Religiones } from '../fom-config/data';

@Injectable({ providedIn: 'root' })
export class ReliginDataProvider implements IEntityDataProvider<any[]> {
  private readonly dataReligines: any[] = Religiones;

  fetch(): Observable<any[]> {
    return of(this.dataReligines);
  }
}

@Injectable({ providedIn: 'root' })
export class DoctorinDataProvider implements IEntityDataProvider<any[]> {
  private readonly dataDoctorin: any[] = Doctrines;

  fetch(): Observable<any[]> {
    return of([]);
  }

  onChangeRelatedEntity(religin: string): Observable<any[]> {
    const doctorineList = this.dataDoctorin.filter((item) =>
      item.related.includes(religin)
    );

    return of(doctorineList);
  }
}
